<ion-segment #segment (ionChange)="activeTabChange($event)" [value]="activeTab">
  <ion-segment-button value="inbound">Příchozí</ion-segment-button>
  <ion-segment-button value="outbound">Odeslané</ion-segment-button>
</ion-segment>

<ion-content>
  <app-private-messages-list
    [messageDirection]="'inbound'"
    *ngIf="activeTab === 'inbound'"
    [sortedMessages]="sortedInboundMessages$ | async"
    (loadMessagesFromOffset)="loadMoreInboundMsgs($event)"
    (replyToMessage)="replyToMessage.emit($event)"
    (filterByAssistantId)="filterByAssistantId.emit($event)"
    (filterByClientId)="filterByClientId.emit($event)"
    (filterByUserId)="filterBySenderId.emit($event)"
    (fetchOnlyUnread)="fetchOnlyUnread.emit($event)"
  ></app-private-messages-list>

  <app-private-messages-list
    [messageDirection]="'outbound'"
    *ngIf="activeTab === 'outbound'"
    [sortedMessages]="sortedOutboundMessages$ | async"
    [allowFilters]="false"
    [allowReadUnreadControl]="false"
    (loadMessagesFromOffset)="loadMoreOutboundMsgs($event)"
    (replyToMessage)="replyToMessage.emit($event)"
  ></app-private-messages-list>
</ion-content>
